<section
  class="mbs-wizard_form"
  [formGroup]="stepForm">
  <div class="mbs-wizard_form-content">
    <ng-container>
      <mbs-retention-policy-storage-info [storage]="storage"></mbs-retention-policy-storage-info>
    </ng-container>

    <mbs-alert
      *ngIf="needShowMinPeriodAlert"
      [attr.data-e2e]="elementsSelector.name.minPeriodAlert"
      [icon]="true"
      [type]="mbsPopupType.warning">
      <span *ngFor="let item of retentionPolicyMinPeriodAlert">
        {{ item }}
      </span>
    </mbs-alert>

    <mbs-alert
      *ngIf="isRDMode && importedPlanChanged"
      [attr.data-e2e]="elementsSelector.name.notSupportedAlert"
      [icon]="true"
      [type]="mbsPopupType.warning">
      {{ 'wizards:whereBackup.where_backup_config_not_supported' | i18next }}
    </mbs-alert>

    <mbs-alert
      *ngIf="isNBF && !isFullBackup && !isFFIMode"
      [attr.data-e2e]="elementsSelector.name.notFullAlert"
      [icon]="true"
      [type]="mbsPopupType.warning">
      {{ 'wizards:retention_policy_not_full_alert' | i18next }}
    </mbs-alert>

    <!--is archive start-->
    <div
      *ngIf="isNBF"
      [attr.data-e2e]="elementsSelector.name.nbfBlock">
      <div class="mbs-form_section">
        <mbs-form-group>
          <mbs-radio
            formControlName="RetentionUseDefaultSettings"
            name="RetentionUseDefaultSettings"
            [disabledSelf]="isFFIMode"
            [id]="'selection-use-defaults-1'"
            [label]="'wizards:do_not_purge_label' | i18next"
            [value]="true"
            (change)="doNotPurgeChangeHandler($event)"></mbs-radio>
          <mbs-radio
            formControlName="RetentionUseDefaultSettings"
            name="RetentionUseDefaultSettings"
            [descriptionOutside]="false"
            [id]="'selection-use-defaults-2'"
            [label]="'wizards:keep_backup_label' | i18next"
            [value]="false"
            (change)="doNotPurgeChangeHandler($event)">
            <ng-template radioDescription>
              <mbs-form-group>
                <div class="form-row align-items-center">
                  <div class="col-2">
                    <mbs-number
                      formControlName="deleteVersionsOlderThanCount"
                      [id]="'ibb-deleteVersionsOlderThanCount'"
                      [min]="1"></mbs-number>
                  </div>
                  <div class="col-3">
                    <mbs-select
                      formControlName="deleteVersionsOlderThanPeriod"
                      [appendTo]="'.modal-content'"
                      [bindLabel]="'label'"
                      [bindValue]="'value'"
                      [clearable]="false"
                      [id]="'PeriodEnumSelect'"
                      [items]="periodEnumSelectArray"
                      [searchable]="false"
                      (change)="keepBackupForPeriodChangeHandler()"></mbs-select>
                  </div>
                  <div class="col-1">
                    <span
                      class="fa fa-info-circle ml-2 cursor-help text-info"
                      tooltipClass="tooltip-xl"
                      [container]="'body'"
                      [ngbTooltip]="
                        isFFIMode ? ('wizards:delete_version_tooltip_ffi' | i18next) : ('wizards:delete_version_tooltip' | i18next)
                      "
                      [placement]="['bottom-left', 'bottom']"></span>
                  </div>
                </div>
                <mbs-input-errors
                  *ngIf="isFFIMode"
                  [errors]="[{ message: keepBackupFFIAlert }]"></mbs-input-errors>
                <mbs-input-errors [errors]="[{ message: keepBackupStorageObjectLockAlert }]"></mbs-input-errors>
              </mbs-form-group>
            </ng-template>
          </mbs-radio>
        </mbs-form-group>

        <mbs-form-group
          *ngIf="(!isUnix || isNetBuild) && showGFS"
          class="mb-0"
          formGroupName="GFSPolicySettings"
          [attr.data-e2e]="elementsSelector.name.showGFSBlock">
          <mbs-checkbox
            formControlName="enabled"
            [descriptionOutside]="false"
            [label]="'wizards:gfs_label' | i18next"
            (change)="enableGFSChangeHandler($event)">
            <ng-container appendLabel>
              <span
                class="fa fa-info-circle ml-2 cursor-help text-info"
                [ngbTooltip]="'wizards:gfs_label_tooltip' | i18next"></span>
            </ng-container>
            <ng-template checkboxDescription>
              <div class="text-xs mb-3">
                <span *ngFor="let item of gfsLabelDesc; let last = last"> {{ item }}<br *ngIf="!last" /> </span>
              </div>

              <mbs-form-group>
                <div
                  class="row align-items-center"
                  formGroupName="weekly"
                  [class.mb-0]="GFSPolicySettingsCtrl?.controls?.weekly?.controls?.storePeriod?.invalid"
                  [class.mb-2]="!GFSPolicySettingsCtrl?.controls?.weekly?.controls?.storePeriod?.invalid">
                  <div class="col-6">
                    <mbs-checkbox
                      formControlName="enabled"
                      [label]="'wizards:period_weekly_label' | i18next"
                      (change)="fullBackupsChangeHandler($event, 'weekly')"></mbs-checkbox>
                  </div>
                  <div class="col-2">
                    <mbs-number
                      formControlName="storePeriod"
                      [id]="'archive-weekly-store-period-number'"
                      [max]="100000"
                      [min]="1"></mbs-number>
                  </div>
                  <div class="col-2">
                    <label
                      class="mbs-form_label mb-0"
                      for="archive-weekly-store-period-number"
                      [class.-disabled]="!GFSPolicySettingsCtrl?.controls?.weekly?.controls?.storePeriod?.enabled">
                      {{ 'wizards:weeks_label' | i18next }}
                    </label>
                  </div>
                </div>
                <div
                  *ngIf="GFSPolicySettingsCtrl?.controls?.weekly?.controls?.storePeriod?.invalid"
                  class="row mb-2">
                  <div class="col-6 offset-6">
                    <mbs-input-errors
                      [errors]="[
                        {
                          message: GFSPolicySettingsCtrl?.controls?.weekly?.controls?.storePeriod?.errors?.moreThanMonthly
                            ? 'This period cannot be longer than monthly one'
                            : GFSPolicySettingsCtrl?.controls?.weekly?.controls?.storePeriod?.errors?.moreThanYearly
                              ? 'This period cannot be longer than yearly one'
                              : ''
                        }
                      ]"></mbs-input-errors>
                  </div>
                </div>

                <div
                  class="row align-items-center"
                  formGroupName="monthly"
                  [class.mb-0]="GFSPolicySettingsCtrl?.controls?.monthly?.controls?.storePeriod?.invalid"
                  [class.mb-2]="!GFSPolicySettingsCtrl?.controls?.monthly?.controls?.storePeriod?.invalid">
                  <div class="col-6">
                    <mbs-checkbox
                      formControlName="enabled"
                      [label]="'wizards:period_monthly_label' | i18next"
                      (change)="fullBackupsChangeHandler($event, 'monthly')"></mbs-checkbox>
                  </div>
                  <div class="col-2">
                    <mbs-number
                      formControlName="storePeriod"
                      [id]="'archive-monthly-store-period-number'"
                      [max]="10000"
                      [min]="1"
                      (change)="monthlyStorePeriodChangeHandler()"></mbs-number>
                  </div>
                  <div class="col-2">
                    <label
                      class="mbs-form_label mb-0"
                      for="archive-monthly-store-period-number"
                      [class.-disabled]="!GFSPolicySettingsCtrl?.controls?.monthly?.controls?.storePeriod?.enabled">
                      {{ 'wizards:months_label' | i18next }}
                    </label>
                  </div>
                </div>
                <div
                  *ngIf="GFSPolicySettingsCtrl?.controls?.monthly?.controls?.storePeriod?.invalid"
                  class="row mb-2">
                  <div class="col-6 offset-6">
                    <mbs-input-errors
                      [errors]="[
                        {
                          message: GFSPolicySettingsCtrl?.controls?.monthly?.controls?.storePeriod?.errors?.moreThanYearly
                            ? 'This period cannot be longer than yearly one'
                            : ''
                        }
                      ]"></mbs-input-errors>
                  </div>
                </div>

                <ng-container formGroupName="yearly">
                  <div class="row align-items-center mb-3">
                    <div class="col-6">
                      <mbs-checkbox
                        formControlName="enabled"
                        [label]="'wizards:period_yearly_label' | i18next"
                        (change)="fullBackupsChangeHandler($event, 'yearly')"></mbs-checkbox>
                    </div>
                    <div class="col-2">
                      <mbs-number
                        formControlName="storePeriod"
                        [id]="'archive-yearly-store-period-number'"
                        [max]="1000"
                        [min]="1"
                        (change)="yearlyStorePeriodChangeHandler()"></mbs-number>
                    </div>
                    <div class="col-2">
                      <label
                        class="mbs-form_label mb-0"
                        for="archive-yearly-store-period-number"
                        [class.-disabled]="!GFSPolicySettingsCtrl?.controls?.yearly?.controls?.storePeriod?.enabled">
                        {{ 'wizards:years_label' | i18next }}
                      </label>
                    </div>
                  </div>
                  <div class="row align-items-center mb-3">
                    <div class="col-6">
                      <label
                        class="mbs-form_label mb-0"
                        for="archive-take-backup-from-month-select"
                        [class.-disabled]="!GFSPolicySettingsCtrl?.controls?.yearly?.controls?.takeBackupFromMonth?.enabled">
                        {{ 'wizards:first_successful_label' | i18next }}
                      </label>
                    </div>
                    <div class="col-3">
                      <mbs-select
                        formControlName="takeBackupFromMonth"
                        [appendTo]="'.modal-content'"
                        [bindLabel]="'label'"
                        [bindValue]="'value'"
                        [clearable]="false"
                        [dropdownPosition]="'auto'"
                        [id]="'archive-take-backup-from-month-select'"
                        [items]="monthNames"
                        [searchable]="false"></mbs-select>
                    </div>
                  </div>
                </ng-container>

                <ng-container *ngIf="correctlyVersionForImmutability">
                  <ng-template #labelImmutability>
                    {{ 'wizards:retention_enable_immutability' | i18next }}
                    <a
                      *ngIf="ability.can('read', 'HelpMarketing'); else onlyText"
                      href="/AP/Help/backup-and-restore/about-backup/gfs/immutability"
                      target="_blank">
                      {{ 'wizards:retention_immutability' | i18next }}
                    </a>
                    <ng-template #onlyText>{{ 'wizards:retention_immutability' | i18next }}</ng-template>
                  </ng-template>
                  <mbs-form-group>
                    <mbs-checkbox
                      formControlName="enabledImmutability"
                      [label]="labelImmutability"
                      (change)="enableImmutabilityChangeHandler($event)">
                      <ng-container appendLabel>
                        <span
                          class="fa fa-info-circle ml-2 cursor-help text-info"
                          [ngbTooltip]="'wizards:retention_immutability_tooltip' | i18next"></span>
                      </ng-container>
                    </mbs-checkbox>
                  </mbs-form-group>
                </ng-container>

                <mbs-alert
                  *ngIf="!showImmutability"
                  [class.mb-0]="!isShowAlert"
                  [icon]="true"
                  [type]="mbsPopupType.warning">
                  {{ 'wizards:retention_immutability_alert' | i18next }}
                  <a
                    target="_blank"
                    [helpLink]="'/AP/Help/backup/about/gfs/immutability'"
                    [kbMode]="true">
                    {{ 'wizards:learn_more_link' | i18next }}
                  </a>
                </mbs-alert>

                <mbs-alert
                  *ngIf="isShowAlert"
                  class="mb-0"
                  [icon]="true"
                  [type]="mbsPopupType.warning">
                  {{
                    'wizards:enable_gfs_alert'
                      | i18next
                        : (GFSPolicySettingsCtrl?.controls?.weekly?.controls?.enabled.value
                            ? { firstPeriod: 'weekly', secondPeriod: 'week' }
                            : GFSPolicySettingsCtrl?.controls?.monthly?.controls?.enabled.value
                              ? { firstPeriod: 'monthly', secondPeriod: 'month' }
                              : GFSPolicySettingsCtrl?.controls?.yearly?.controls?.enabled.value
                                ? { firstPeriod: 'yearly', secondPeriod: 'month' }
                                : {
                                    firstPeriod: '',
                                    secondPeriod: ''
                                  })
                  }}
                  <mbs-button
                    [isCtrl]="true"
                    [size]="MbsSize.md"
                    [type]="'primary'"
                    (click)="changeBackupScheduleClickHandler()">
                    {{ 'wizards:enable_gfs_alert_change_schedule' | i18next }} </mbs-button
                  ><br />
                  <a
                    *ngIf="ability.can('read', 'HelpMarketing')"
                    href="/AP/Help/backup-and-restore/about-backup/gfs/gfs"
                    target="_blank">
                    {{ 'shared:buttons.learnMore' | i18next }}
                  </a>
                </mbs-alert>
              </mbs-form-group>
            </ng-template>
          </mbs-checkbox>
        </mbs-form-group>

        @if (isRDMode && minPeriod && isFFIMode && showIntelligentRetention) {
          <mbs-alert
            class="mb-0"
            [icon]="true"
            [type]="MbsPopupType.info">
            <strong>
              {{ 'wizards:retention.simpleSchedule.minPeriodAlertTitle' | i18next: { name: storage.name } }}
            </strong>
            <div class="mt-1">
              {{ 'wizards:retention.simpleSchedule.minPeriodAlert' | i18next: { name: storage.name, minPeriod: minPeriod } }}.&nbsp;
              <a
                class="ml-2 no-wrap"
                target="_blank"
                [helpLink]="'/AP/Help/backup/about/retention-policy'"
                [kbMode]="true">
                {{ 'shared:buttons.learnMore' | i18next }}
              </a>
            </div>
          </mbs-alert>
        }

        <mbs-form-group *ngIf="!isRDMode && isFFIMode && showIntelligentRetention">
          <mbs-checkbox
            formControlName="intelligentRetention"
            [disabledSelf]="disableIntelligentRetention"
            [label]="'wizards:intelligent_retention_label' | i18next"
            (change)="intelligentRetentionChangeHandler($event)">
            <ng-container appendLabel>
              <span
                class="fa fa-info-circle ml-2 cursor-help text-info"
                tooltipClass="tooltip-xl"
                [container]="'body'"
                [ngbTooltip]="'To disable \'Intelligent Retention\', please request assistance from the Support Team'"></span>
            </ng-container>
          </mbs-checkbox>
          <div class="mt-4">
            <p class="text-md mb-1">
              <strong>{{ 'wizards:intelligent_retention_about_label' | i18next }}</strong>
            </p>
            <p class="text-md mb-1">
              {{ 'wizards:intelligent_retention_about' | i18next }}
              <a
                *ngIf="ability.can('read', 'HelpMarketing')"
                href="/AP/Help/backup/about/ir"
                target="_blank">
                {{ 'wizards:intelligent_retention_about_link' | i18next }}
              </a>
            </p>
            <p class="text-md mb-1">
              <strong>{{ 'wizards:intelligent_retention_FAQ_label' | i18next }}</strong>
            </p>
            <p class="text-md mb-4">
              {{ 'wizards:intelligent_retention_FAQ' | i18next }}
            </p>
            <p class="text-md mb-4">
              <a
                *ngIf="ability.can('read', 'HelpMarketing')"
                href="/AP/Help/backup/about/backup-format/ffi"
                target="_blank">
                {{ 'wizards:learn_more_link' | i18next }}
                <span class="ml-1 fa fa-external-link"></span>
              </a>
            </p>
          </div>
        </mbs-form-group>
      </div>
    </div>
    <!--is archive end-->

    <!--is not archive start-->
    <div
      *ngIf="!isNBF"
      [attr.data-e2e]="elementsSelector.name.notNBFBlock">
      <div class="mbs-form_section">
        <mbs-form-group class="mb-0">
          <mbs-radio
            formControlName="RetentionUseDefaultSettings"
            name="RetentionUseDefaultSettings"
            [id]="'selection-use-defaults-1'"
            [label]="'wizards:use_default_label' | i18next"
            [value]="true"
            (change)="retentionUseDefaultSettingsChangeHandler($event)"></mbs-radio>

          <mbs-radio
            formControlName="RetentionUseDefaultSettings"
            name="RetentionUseDefaultSettings"
            [descriptionOutside]="false"
            [id]="'selection-use-defaults-2'"
            [label]="'wizards:not_use_default_label' | i18next"
            [value]="false"
            (change)="retentionUseDefaultSettingsChangeHandler($event)">
            <ng-template radioDescription>
              <div
                *ngIf="!isBackupPlan && !isSQLPlan"
                [attr.data-e2e]="elementsSelector.name.notSQLNotFileBlock">
                <mbs-form-group>
                  <mbs-checkbox
                    formControlName="deleteVersionsOlderThan"
                    [descriptionOutside]="false"
                    [label]="'wizards:delete_older_then_label' | i18next"
                    (change)="deleteVersionsOlderThanChangeHandler($event)">
                    <ng-template checkboxDescription>
                      <mbs-form-group>
                        <div class="form-row align-items-center">
                          <div class="col-2">
                            <mbs-number
                              formControlName="deleteVersionsOlderThanCount"
                              [id]="'ibb-deleteVersionsOlderThanCount'"
                              [min]="1"></mbs-number>
                          </div>
                          <div class="col-3">
                            <mbs-select
                              formControlName="deleteVersionsOlderThanPeriod"
                              [bindLabel]="'label'"
                              [bindValue]="'value'"
                              [clearable]="false"
                              [id]="'PeriodEnumSelect'"
                              [items]="periodEnumSelectArray"
                              [searchable]="false"></mbs-select>
                          </div>
                        </div>

                        <mbs-input-errors
                          *ngIf="stepForm.get('deleteVersionsOlderThan').value"
                          [errors]="[{ message: keepBackupStorageObjectLockAlert }]"></mbs-input-errors>
                      </mbs-form-group>
                    </ng-template>
                  </mbs-checkbox>
                </mbs-form-group>

                <mbs-form-group>
                  <div class="form-row align-items-center">
                    <div class="col-auto">
                      <mbs-checkbox
                        formControlName="keepNumberOfVersions"
                        [descriptionOutside]="false"
                        [label]="'wizards:keep_versions_label' | i18next"
                        (change)="keepNumberOfVersionsChangeHandler($event)"></mbs-checkbox>
                    </div>
                    <div class="col-2">
                      <mbs-number
                        formControlName="RetentionNumberOfVersions"
                        [id]="'ibb-retention-number-of-versions-number'"
                        [max]="32767"
                        [min]="1"></mbs-number>
                    </div>
                    <div class="col-auto">
                      <label
                        class="mbs-form_label mb-0"
                        for="ibb-retention-number-of-versions-number"
                        [class.-disabled]="stepForm.get('RetentionNumberOfVersions').disabled">
                        {{ 'wizards:for_each_file_label' | i18next }}
                      </label>
                    </div>
                  </div>
                </mbs-form-group>
              </div>

              <div
                *ngIf="isBackupPlan || isSQLPlan"
                [attr.data-e2e]="elementsSelector.name.isSQLorFileBlock">
                <mbs-form-group>
                  <mbs-checkbox
                    formControlName="deleteVersionsOlderThan"
                    [descriptionOutside]="false"
                    [id]="'main-delete-versions-older-than-checkbox'"
                    [label]="'wizards:delete_older_then_label' | i18next"
                    (change)="deleteVersionsOlderThanChangeHandler($event)">
                    <ng-template checkboxDescription>
                      <mbs-form-group>
                        <div class="row">
                          <div class="col-11">
                            <div class="form-row align-items-center">
                              <div class="col-2">
                                <mbs-number
                                  formControlName="deleteVersionsOlderThanCount"
                                  [id]="'main-delete-versions-older-than-count-number'"
                                  [max]="10000"
                                  [min]="1"></mbs-number>
                              </div>
                              <div class="col-3">
                                <mbs-select
                                  formControlName="deleteVersionsOlderThanPeriod"
                                  [bindLabel]="'label'"
                                  [bindValue]="'value'"
                                  [clearable]="false"
                                  [id]="'main-delete-versions-older-than-period-select'"
                                  [items]="periodEnumSelectArray"
                                  [searchable]="false"></mbs-select>
                              </div>
                              <div class="col-auto">
                                <label
                                  class="mbs-form_label mb-0"
                                  for="main-from-time-select"
                                  [class.-disabled]="stepForm.get('fromTimeSelected').disabled">
                                  {{ 'wizards:from_label' | i18next }}
                                </label>
                              </div>
                              <div
                                class="col-4"
                                [attr.data-e2e]="elementsSelector.name.fromTimeSelectedBlock">
                                <mbs-select
                                  formControlName="fromTimeSelected"
                                  [bindLabel]="'label'"
                                  [bindValue]="'value'"
                                  [clearable]="false"
                                  [id]="'main-from-time-select'"
                                  [items]="fromTimeSelectedItems"
                                  [searchable]="false"
                                  (change)="fromTimeSelectedChangeHandler($event)"></mbs-select>
                              </div>
                            </div>
                          </div>
                        </div>

                        <mbs-input-errors
                          *ngIf="stepForm.get('deleteVersionsOlderThan').value"
                          [errors]="[{ message: keepBackupStorageObjectLockAlert }]"></mbs-input-errors>
                      </mbs-form-group>

                      <mbs-form-group
                        *ngIf="!isSQLPlan"
                        [attr.data-e2e]="elementsSelector.name.alwaysKeepLastVersionBlock">
                        <div class="form-row align-items-center">
                          <div class="col-auto">
                            <mbs-checkbox
                              formControlName="alwaysKeepLastVersion"
                              [id]="'main-always-keep-last-version-checkbox'"
                              [label]="'wizards:always_keep_label' | i18next"></mbs-checkbox>
                          </div>
                          <div
                            *ngIf="isShowWarning"
                            class="col"
                            [attr.data-e2e]="elementsSelector.name.daysAgoAlert">
                            <mbs-alert
                              class="mb-0"
                              [icon]="false"
                              [type]="mbsPopupType.warning">
                              {{ 'wizards:days_ago_alert' | i18next: { count: daysCount } }}
                            </mbs-alert>
                          </div>
                        </div>
                      </mbs-form-group>
                    </ng-template>
                  </mbs-checkbox>
                </mbs-form-group>

                <mbs-form-group>
                  <div class="row">
                    <div class="col-10">
                      <div class="form-row align-items-center">
                        <div class="col-auto">
                          <mbs-checkbox
                            formControlName="keepNumberOfVersions"
                            [descriptionOutside]="false"
                            [id]="'main-keep-number-of-versions-checkbox'"
                            [label]="'wizards:keep_versions_label' | i18next"
                            (change)="keepNumberOfVersionsChangeHandler($event)">
                          </mbs-checkbox>
                        </div>
                        <div class="col-2">
                          <mbs-number
                            formControlName="RetentionNumberOfVersions"
                            [id]="'main-retention-number-of-versions-number'"
                            [max]="32767"
                            [min]="1"></mbs-number>
                        </div>
                        <div class="col-auto">
                          <label
                            class="mbs-form_label mb-0"
                            for="main-retention-number-of-versions-number"
                            [class.-disabled]="stepForm.get('RetentionNumberOfVersions').disabled">
                            {{ 'wizards:for_each_file_label' | i18next }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </mbs-form-group>

                <mbs-form-group
                  *ngIf="(!isUnix || isNetBuild) && !isSQLPlan"
                  class="mb-0"
                  [attr.data-e2e]="elementsSelector.name.notUnixBlock">
                  <div class="row">
                    <div class="col-10">
                      <div class="form-row align-items-center">
                        <div class="col-auto">
                          <mbs-checkbox
                            formControlName="delayPurgeForEnabled"
                            [id]="'main-delay-purge-for-enabled-checkbox'"
                            [label]="'wizards:delay_purge_label' | i18next"
                            (change)="delayPurgeForEnabledChangeHandler($event)"></mbs-checkbox>
                        </div>
                        <div class="col-2">
                          <mbs-number
                            formControlName="delayPurgeFor"
                            [id]="'main-delay-purge-for-number'"
                            [max]="10000"
                            [min]="1"></mbs-number>
                        </div>
                        <div class="col-3">
                          <mbs-select
                            formControlName="delayPurgeForSelect"
                            [bindLabel]="'label'"
                            [bindValue]="'value'"
                            [clearable]="false"
                            [id]="'main-delay-purge-for-select'"
                            [items]="periodEnumSelectArray"
                            [searchable]="false"></mbs-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </mbs-form-group>
              </div>
            </ng-template>
          </mbs-radio>
        </mbs-form-group>
      </div>

      <div
        *ngIf="isBackupPlan && !isHybrid"
        [attr.data-e2e]="elementsSelector.name.fileTypeNotHybrid">
        <div class="mbs-form_section">
          <mbs-form-group class="mb-0">
            <mbs-checkbox
              formControlName="deleteIfLocallyDeleted"
              [descriptionOutside]="false"
              [label]="'wizards:delete_files_label' | i18next"
              (change)="deleteIfLocallyDeletedChangeHandler($event)">
              <ng-template checkboxDescription>
                <div class="form-row align-items-center flex-nowrap">
                  <div class="col-auto">
                    <label
                      class="mbs-form_label mb-0"
                      for="deleteAfter"
                      [class.-disabled]="stepForm.get('deleteAfter').disabled">
                      {{ 'wizards:delete_after_label' | i18next }}
                    </label>
                  </div>
                  <div class="col-2">
                    <mbs-number
                      formControlName="deleteAfter"
                      [max]="10000"
                      [min]="1"></mbs-number>
                  </div>
                  <div class="col-auto">
                    <label
                      class="mbs-form_label mb-0"
                      for="deleteAfter"
                      [class.-disabled]="stepForm.get('deleteAfter').disabled">
                      {{ 'wizards:days_label' | i18next }}
                    </label>
                  </div>
                  <div
                    *ngIf="!isUnix || isNetBuild"
                    class="col"
                    [attr.data-e2e]="elementsSelector.name.fileTypeNotHybridNotUnix">
                    <mbs-checkbox
                      formControlName="doNotShowWarning"
                      [label]="'wizards:not_show_warning_label' | i18next"></mbs-checkbox>
                  </div>
                </div>
              </ng-template>
            </mbs-checkbox>
          </mbs-form-group>

          <mbs-alert
            *ngIf="stepForm.get('deleteIfLocallyDeleted')?.value"
            class="mb-0 mt-3"
            [attr.data-e2e]="elementsSelector.name.deleteIfLocallyDeletedAlert"
            [icon]="true"
            [type]="mbsPopupType.info">
            <span *ngFor="let item of deleteFilesLabelAlert; let last = last"> {{ item }}<br *ngIf="!last" /> </span>
          </mbs-alert>
        </div>
      </div>

      <div
        *ngIf="isHybrid"
        class="mbs-form_section"
        formGroupName="HybridRetentionPolicy"
        [attr.data-e2e]="elementsSelector.name.cbfHybridBlock">
        <mbs-form-group>
          <mbs-checkbox
            formControlName="RetentionUseDefaultSettings"
            [descriptionOutside]="false"
            [label]="'wizards:use_default_hybrid_label' | i18next"
            (change)="retentionUseDefaultSettingsChangeHandler($event, true)">
            <ng-template
              checkboxDescription
              [hide]="!stepForm.get('HybridRetentionPolicy').value.RetentionUseDefaultSettings">
              <div
                *ngIf="!isBackupPlan && !isSQLPlan"
                [attr.data-e2e]="elementsSelector.name.hybridNotFileBlock">
                <mbs-form-group>
                  <mbs-checkbox
                    formControlName="deleteVersionsOlderThan"
                    [descriptionOutside]="false"
                    [label]="'wizards:delete_older_then_label' | i18next"
                    (change)="deleteVersionsOlderThanChangeHandler($event, true)">
                    <ng-template checkboxDescription>
                      <mbs-form-group>
                        <div class="form-row align-items-center">
                          <div class="col-2">
                            <mbs-number
                              formControlName="deleteVersionsOlderThanCount"
                              [id]="'hybrid-ibb-deleteVersionsOlderThanCount'"
                              [max]="10000"
                              [min]="1"></mbs-number>
                          </div>
                          <div class="col-3">
                            <mbs-select
                              formControlName="deleteVersionsOlderThanPeriod"
                              [appendTo]="'.modal-content'"
                              [bindLabel]="'label'"
                              [bindValue]="'value'"
                              [clearable]="false"
                              [id]="'hybrid-PeriodEnumSelect'"
                              [items]="periodEnumSelectArray"
                              [searchable]="false"></mbs-select>
                          </div>
                        </div>
                      </mbs-form-group>
                    </ng-template>
                  </mbs-checkbox>
                </mbs-form-group>

                <mbs-form-group>
                  <div class="form-row align-items-center">
                    <div class="col-auto">
                      <mbs-checkbox
                        formControlName="keepNumberOfVersions"
                        [descriptionOutside]="false"
                        [label]="'wizards:keep_versions_label' | i18next"
                        (change)="keepNumberOfVersionsChangeHandler($event, true)"></mbs-checkbox>
                    </div>
                    <div class="col-2">
                      <mbs-number
                        formControlName="RetentionNumberOfVersions"
                        [id]="'hybrid-ibb-retention-number-of-versions-number'"
                        [max]="32767"
                        [min]="1"></mbs-number>
                    </div>
                    <div class="col-auto">
                      <label
                        class="mbs-form_label mb-0"
                        for="hybrid-ibb-retention-number-of-versions-number"
                        [class.-disabled]="HybridRetentionPolicyCtrl?.controls?.RetentionNumberOfVersions.disabled">
                        {{ 'wizards:for_each_file_label' | i18next }}
                      </label>
                    </div>
                  </div>
                </mbs-form-group>
              </div>

              <div
                *ngIf="isBackupPlan || isSQLPlan"
                [attr.data-e2e]="elementsSelector.name.hybridFileOrSQLBlock">
                <mbs-form-group>
                  <mbs-checkbox
                    formControlName="deleteVersionsOlderThan"
                    [descriptionOutside]="false"
                    [id]="'hybrid-delete-versions-older-than-checkbox'"
                    [label]="'wizards:delete_older_then_label' | i18next"
                    (change)="deleteVersionsOlderThanChangeHandler($event, true)">
                    <ng-template checkboxDescription>
                      <mbs-form-group>
                        <div class="form-row align-items-center">
                          <div class="col-2">
                            <mbs-number
                              formControlName="deleteVersionsOlderThanCount"
                              [id]="'hybrid-delete-versions-older-than-count-number'"
                              [max]="10000"
                              [min]="1"></mbs-number>
                          </div>
                          <div class="col-3">
                            <mbs-select
                              formControlName="deleteVersionsOlderThanPeriod"
                              [bindLabel]="'label'"
                              [bindValue]="'value'"
                              [clearable]="false"
                              [id]="'hybrid-delete-versions-older-than-period-select'"
                              [items]="periodEnumSelectArray"
                              [searchable]="false"></mbs-select>
                          </div>
                          <div
                            *ngIf="!isSQLPlan"
                            class="col-auto"
                            [attr.data-e2e]="elementsSelector.name.hybridFromTimeSelectedBlockLabel">
                            <label
                              class="mbs-form_label mb-0"
                              for="hybrid-from-time-select"
                              [class.-disabled]="stepForm.get('fromTimeSelected').disabled">
                              {{ 'wizards:from_label' | i18next }}
                            </label>
                          </div>
                          <div
                            *ngIf="!isSQLPlan"
                            class="col-4"
                            [attr.data-e2e]="elementsSelector.name.hybridFromTimeSelectedBlock">
                            <mbs-select
                              formControlName="fromTimeSelected"
                              [bindLabel]="'label'"
                              [bindValue]="'value'"
                              [clearable]="false"
                              [id]="'hybrid-from-time-select'"
                              [items]="fromTimeSelectedItems"
                              [searchable]="false"
                              (change)="fromTimeSelectedChangeHandler($event, true)"></mbs-select>
                          </div>
                        </div>

                        <mbs-input-errors
                          *ngIf="stepForm.get('deleteVersionsOlderThan').value"
                          [errors]="[{ message: keepBackupStorageObjectLockAlert }]"></mbs-input-errors>
                      </mbs-form-group>

                      <mbs-form-group
                        *ngIf="!isSQLPlan"
                        [attr.data-e2e]="elementsSelector.name.hybridAlwaysKeepLastVersionBlock">
                        <mbs-checkbox
                          formControlName="alwaysKeepLastVersion"
                          [id]="'hybrid-always-keep-last-version-checkbox'"
                          [label]="'wizards:always_keep_label' | i18next"></mbs-checkbox>
                      </mbs-form-group>
                    </ng-template>
                  </mbs-checkbox>
                </mbs-form-group>

                <mbs-form-group>
                  <div class="row">
                    <div class="col-10">
                      <div class="form-row align-items-center">
                        <div class="col-auto">
                          <mbs-checkbox
                            formControlName="keepNumberOfVersions"
                            [descriptionOutside]="false"
                            [id]="'hybrid-keep-number-of-versions-checkbox'"
                            [label]="'wizards:keep_versions_label' | i18next"
                            (change)="keepNumberOfVersionsChangeHandler($event, true)"></mbs-checkbox>
                        </div>
                        <div class="col-2">
                          <mbs-number
                            formControlName="RetentionNumberOfVersions"
                            [id]="'hybrid-retention-number-of-versions-number'"
                            [max]="32767"
                            [min]="1"></mbs-number>
                        </div>
                        <div class="col-auto">
                          <label
                            class="mbs-form_label mb-0"
                            for="hybrid-retention-number-of-versions-number"
                            [class.-disabled]="HybridRetentionPolicyCtrl?.controls?.RetentionNumberOfVersions.disabled">
                            {{ 'wizards:for_each_file_label' | i18next }}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </mbs-form-group>

                <mbs-form-group
                  *ngIf="(!isUnix || isNetBuild) && !isSQLPlan"
                  [attr.data-e2e]="elementsSelector.name.hybridNotUnixBlock">
                  <div class="row">
                    <div class="col-10">
                      <div class="form-row align-items-center">
                        <div class="col-auto">
                          <mbs-checkbox
                            formControlName="delayPurgeForEnabled"
                            [id]="'hybrid-delay-purge-for-enabled-checkbox'"
                            [label]="'wizards:delay_purge_label' | i18next"
                            (change)="delayPurgeForEnabledChangeHandler($event, true)"></mbs-checkbox>
                        </div>
                        <div class="col-2">
                          <mbs-number
                            formControlName="delayPurgeFor"
                            [id]="'hybrid-delay-purge-for-number'"
                            [max]="10000"
                            [min]="1"></mbs-number>
                        </div>
                        <div class="col-3">
                          <mbs-select
                            formControlName="delayPurgeForSelect"
                            [bindLabel]="'label'"
                            [bindValue]="'value'"
                            [clearable]="false"
                            [dropdownPosition]="'top'"
                            [id]="'hybrid-delay-purge-for-select'"
                            [items]="periodEnumSelectArray"
                            [searchable]="false"></mbs-select>
                        </div>
                      </div>
                    </div>
                  </div>
                </mbs-form-group>
              </div>
            </ng-template>
          </mbs-checkbox>
        </mbs-form-group>
      </div>
    </div>
  </div>
</section>

<ng-template #IntelligentRetentionPayAttention>
  <mbs-alert
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:intelligent_retention_alert_prefix' | i18next }}
    <strong>{{ 'wizards:intelligent_retention_label' | i18next }}</strong>
    {{ 'wizards:intelligent_retention_alert_postfix' | i18next }}
  </mbs-alert>
</ng-template>

<ng-template #confirmNotFullModal>
  <p>{{ 'wizards:not_full_confirm_text' | i18next }}</p>
  <mbs-alert
    class="mb-0"
    [icon]="true"
    [type]="mbsPopupType.warning">
    {{ 'wizards:not_full_confirm_alert_text' | i18next }}
  </mbs-alert>
</ng-template>
